import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#credit-card-interest-app', App);
